// Preload the JS chunk for a route BEFORE the user clicks it.
// Wired to nav items via onMouseEnter (desktop) + onPointerDown (mobile).
// When the user finally clicks, the chunk is already in the browser cache,
// so the route change feels instant.
//
// The map only needs entries for pages users navigate TO from a nav bar.
// Adding an entry that isn't in the map is a no-op — safe by default.

const ROUTE_LOADERS = {
  '/': () => import('../pages/HomeScreen'),

  '/member/home': () => import('../pages/member/Screen_MemberHome'),
  '/member/calendar': () => import('../pages/member/Screen_MemberCalendar'),
  '/member/settings': () => import('../pages/member/Screen_MemberSettings'),
  '/member/carte': () => import('../pages/member/Screen_MemberCarte'),
  '/member/appointments': () => import('../pages/member/Screen_MemberAppointments'),
  '/member/parcours-pastoral': () => import('../pages/member/Screen_MemberParcoursPastoral'),
  '/member/leaders': () => import('../pages/member/Screen_MemberLeaders'),
  '/member/groups': () => import('../pages/member/MemberGroups'),

  '/leader/rdv': () => import('../pages/leader/Screen_LeaderRDV'),
  '/leader/dashboard': () => import('../pages/leader/LeaderDashboard'),


  '/dg/dashboard': () => import('../pages/dg/Screen_DGDashboard'),
  '/dg/sectors': () => import('../pages/dg/Screen_DGSectors'),
  '/dg/leaders': () => import('../pages/dg/Screen_DGTeam'),
  '/dg/members': () => import('../pages/dg/Screen_DGMembers'),
  '/dg/organisation': () => import('../pages/dg/Screen_DGOrganisation'),
  '/dg/settings': () => import('../pages/dg/Screen_DGSettings'),
  '/dg/alerts': () => import('../pages/dg/Screen_DGAlertsHub'),
};

const alreadyPreloaded = new Set();

export function preloadRoute(path) {
  if (!path || alreadyPreloaded.has(path)) return;
  const loader = ROUTE_LOADERS[path];
  if (!loader) return;
  alreadyPreloaded.add(path);
  // Fire the dynamic import. Errors are swallowed — the click will retry
  // and surface real problems through the actual Suspense boundary.
  Promise.resolve().then(loader).catch(() => alreadyPreloaded.delete(path));
}

// Handy props to spread onto any button/link that navigates to `path`.
export function preloadHandlers(path) {
  const fire = () => preloadRoute(path);
  return {
    onMouseEnter: fire,
    onPointerDown: fire,
    onFocus: fire,
  };
}
